import { HeroSlider } from "../../../Fundraising.UI.Shared/Modules/heroSlider/HeroSlider";
import { RedirectModal } from "../../../Fundraising.UI.Shared/Modules/redirectModal/RedirectModal";

const Hero = new HeroSlider("#hero-slide-container", {
    delay: 5000,
    slides: [
        "/Assets/images/hero/hero1.jpg",
        "/Assets/images/hero/hero2.jpg",
        "/Assets/images/hero/hero3.jpg",
        "/Assets/images/hero/hero4.jpg",
        "/Assets/images/hero/hero5.jpg",
        "/Assets/images/hero/hero1.jpg"
    ],
    infinite: false
});


    window.addEventListener('DOMContentLoaded', function () {
        const redirection = new RedirectModal({
            title: "American Publishers is now Funderworks",
            message: "You have been redirected to  Funderworks.com from APMags.com."
        });
    });



(function ($) {
    const bgModalClass = 'bg-overlay';
    const bgModalId = 'bg-overlay';
    const menuOpenClass = 'nav-open';

    $(document).on('click', '#menu-trigger', function (e) {
        const $body = $('body');
        const $navbar = $('header .navbar');

        if ($body.hasClass(menuOpenClass)) {
            $body.removeClass(menuOpenClass);
            $navbar.css('position', 'relative');
            hideOverlayBackground();
        } else {
            $body.addClass(menuOpenClass);
            $navbar.css('position', 'static');
            showOverlayBackground();
        }
    });

    $(document).on('click', '.menu-trigger', function (e) {
        const $body = $('body');
        if ($body.hasClass(menuOpenClass)) {
            hideDropDownMenu();
            $body.removeClass(menuOpenClass);
            hideOverlayBackground();
            window.setTimeout(function () {
                showDropDownMenu();
            }, 1000);
        } else {
            $body.addClass(menuOpenClass);
            showOverlayBackground();
        }
    });

    function hideDropDownMenu() {
        $('.category-menu').addClass('d-none');
    }

    function showDropDownMenu() {
        $('.category-menu').removeClass('d-none');
    }

    function hideOverlayBackground() {
        const bgModal = document.getElementById(bgModalId);
        if (bgModal) {
            bgModal.remove();
        }
    }

    function showOverlayBackground() {
        let bgModal;
        if (!document.getElementById(bgModalClass)) {
            bgModal = document.createElement('div');
            bgModal.id = bgModalId;
            bgModal.classList.add(bgModalClass);
            document.body.appendChild(bgModal);
        } else {
            bgModal = document.getElementsByClassName(bgModalId);
        }
        fadeIn(bgModal, 100);
    }

    // On resize events, recalculate and log
    window.addEventListener('resize', function () {
        closeMobileMenu();
    }, false);

    const closeMobileMenu = () => {
        hideOverlayBackground();
        document.body.classList.remove(menuOpenClass);
    }

    function fadeIn(el, time) {
        el.style.opacity = 0;

        var last = +new Date();
        var tick = function () {
           // @ts-ignore
            el.style.opacity = +el.style.opacity + (new Date() - last) / time;
            last = +new Date();

            if (+el.style.opacity < 1) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
        };

        tick();
    }

    $(document).on('click', '.add-product', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const $container = $btn.closest('.product-group');
        const selectLabel = $btn.data('select-label');
        const selectedLabel = $btn.data('selected-label');

        const $checkbox = $(this).closest('.product-selector').find('input[type=checkbox]');

        if ($checkbox.prop('checked')) {
            $checkbox.prop('checked', false);
            $container.removeClass('selected');
            $btn.html(selectLabel);
        } else {
            $checkbox.prop('checked', true);
            $container.addClass('selected');
            $btn.html(selectedLabel);
        }
    });

})(jQuery);